module.exports = __webpack_public_path__ + "img/sun.12ecacfa.png";